<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="user-mes-title" v-text="addText"></div>
            <ul class="user-mes" v-show="init">
                <li class="user-mes-in cle">
                    <div v-text="addID" :title="addID" class="user-mes-name fl"></div>
                    <input type="text" maxlength="12" v-model="addIDVal" @keyup="limit" @blur="limit" class="user-mes-inp fr">
                </li>
                <li class="user-mes-btn cle">
                    <button type="button" class="fl" @click="next" :title="nextText" v-text="nextText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </li>
            </ul>
            <ul class="user-mes" v-show="isHS || isPA">
                <li class="user-mes-in cle" v-for="(items,index) in mesr" :key="index">
                    <div v-text="items.name" :title="items.name" class="user-mes-name fl"></div>
                    <input :type="items.type" maxlength="60" v-model="items.val" :disabled="index===0 || items.disabled" class="user-mes-inp fr">
                </li>
                <li class="user-mes-btn cle">
                    <button type="button" class="fl" @click="confirm" :title="confirmText" v-text="confirmText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </li>
            </ul>
            <ul class="user-mes" v-show="isSR">
                <li class="user-mes-in cle" v-for="(items,index) in mes" :key="index">
                    <div v-text="items.name" :title="items.name" class="user-mes-name fl"></div>
                    <input :type="items.type" maxlength="60" v-model="items.val" :disabled="index===0" class="user-mes-inp fr">
                </li>
                <li class="user-mes-btn cle" style="margin-top: 10px;">
                    <button type="button" style="border-radius: 3px; border-color: transparent!important; background-color: #BFC7D2!important; width: auto;" class="fr" @click="pdclick" :title="paText" v-text="paText"></button>
                </li>
                <li class="user-mes-btn cle">
                    <button type="button" class="fl" @click="confirm" :title="confirmText" v-text="confirmText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import add from '../assets/js/bomb'
export default {
    name:'AddDevice',
    props:['language'],
    data(){
        return{
            addText:this.lanNow.lan['K022_AddDevice'],
            init:true,
            mes:[
                {name:this.lanNow.lan['K004_CloudID'],type:'text',val:''},
                {name:this.lanNow.lan['K023_DeviceName'],type:'text',val:''},
                {name:this.lanNow.lan['K157_Code'],type:'password',val:''}
            ],
            mesr:[
                {name:this.lanNow.lan['K004_CloudID'],type:'text',val:''},
                {name:this.lanNow.lan['K023_DeviceName'],type:'text',val:''},
                {name:this.lanNow.lan['K005_DeviceUserName'],type:'text',val:''},
                {name:this.lanNow.lan['K006_DevicePwd'],type:'password',val:''}
            ],
            confirmText:this.lanNow.lan['K024_Confirm'],
            cancleText:this.lanNow.lan['K018_Cancel'],
            paText:this.lanNow.lan['K230_Add'],
            isLang:false,
            addID:this.lanNow.lan['K004_CloudID'],
            addIDVal:'',
            isHS:false,
            isPA:false,
            isSR:false,
            nextText:this.lanNow.lan['K167_Next'],
            list:''
        }
    },
    methods:{
        limit:function(){
            var id=(/[a-zA-Z0-9]+/g).exec(this.addIDVal);
            if($.type(id)==='null'){
                id='';
            }else if($.type(id)==='array'){
                id=id[0]==='undefined'?'':id[0];
            };
            this.addIDVal=id;
        },
        next:function(){
            var v=this.addIDVal;
            var r=/^um/g;
            this.mesr[2].disabled = false;
            if(v===''){
                alert(this.language["K146_CloudEmpty"]);
            }else if(r.test(v)){
                this.mesr[0].val=this.addIDVal;
                this.init=false;
                this.isPA=false;
                this.isHS=true;
            }else{
                this.mes[0].val=this.addIDVal;
                this.init=false;
                this.isPA=false;
                this.isSR=true;
            };
        },
        pdclick: function () {
            this.mesr[0].val=this.addIDVal;
            this.init=false;
            this.isSR=false;
            this.isHS=true;
            this.isPA=true;
            this.mesr[2].val = 'admin';
            this.mesr[2].disabled = true;
        },
        confirm:function(){
            this.$emit('list');
            for(var i=0;i<this.list.length;i++){
                for(var j=0;j<this.list[i].length;j++){
                    if(this.list[i][j].id===this.addIDVal){
                        alert(this.language["K166_Exist"]);
                        return false;
                    };
                };
            };
            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str;
            var ConfirmData;
            if(this.isHS || this.isPA){
                if(this.mesr[1].val===''){
                    alert(this.language["K176_Empty"]);
                    return false;
                };
                var num=this.reg.devName.num;
                var leng=this.StrByteCountFun(this.mesr[1].val);
                if(!(leng>=num[0]&&length<=num[1])){
                    alert(this.language['K204_Limit']);
                    return false;
                };
                if(!this.reg.devName.limit.test(this.mesr[1].val)){
                    alert(this.language['K205_Type']);
                    return false;
                };
                if(this.mesr[2].val===''){
                    alert(this.language["K144_UserEmpty"]);
                    return false;
                };
                var numName=this.reg.devUser.num;
                var lengName=this.StrByteCountFun(this.mesr[2].val);
                if(!(lengName>=numName[0]&&lengName<=numName[1])){
                    alert(this.language['K206_Limit']);
                    return false;
                };
                if(!this.reg.devUser.limit.test(this.mesr[2].val)){
                    alert(this.language['K209_Type']);
                    return false;
                };
                var numPwd=this.reg.devPwd.num;
                var lengPwd=this.StrByteCountFun(this.mesr[3].val);
                if(!(lengPwd>=numPwd[0]&&lengPwd<=numPwd[1])){
                    alert(this.language['K208_Limit']);
                    return false;
                };
                if(!this.reg.devPwd.limit.test(this.mesr[3].val)){
                    alert(this.language['K210_Type']);
                    return false;
                };
                if (this.isPA) {
                    ConfirmData = {
                        "header": {
                            "client": {
                                "app": "",
                                "id": "",
                                "oem": oem,
                                "type": 1
                            },
                            "command": "device-add-by-id",
                            "flag": "tdkcloud",
                            "session": sessionId,
                            "user-data": "",
                            "version": "v1.20"
                        },
                        "content": {
                            "duid": this.addIDVal,
                            "device-name": this.mesr[1].val,
                            "device-user": 'admin',
                            "device-pwd": this.mesr[3].val
                        }
                    }
                } else {
                    var str=add.addDeviceSet({
                        sessionId:sessionId,
                        oem:oem,
                        id:this.addIDVal,
                        name:this.mesr[1].val,
                        pwd:JSON.stringify({user:this.mesr[2].val,pwd:this.mesr[3].val})
                    });
                }
            }else if(this.isSR){
                if(this.mes[1].val===''){
                    alert(this.language["K176_Empty"]);
                    return false;
                };
                var num=this.reg.devName.num;
                var leng=this.StrByteCountFun(this.mes[1].val);
                if(!(leng>=num[0]&&length<=num[1])){
                    alert(this.language['K204_Limit']);
                    return false;
                };
                if(!this.reg.devName.limit.test(this.mes[1].val)){
                    alert(this.language['K205_Type']);
                    return false;
                };
                if(this.mes[2].val===''){
                    alert(this.language["K194_CodeEmpty"]);
                    return false;
                };
                var numCode=this.reg.devCode.num;
                var lengCode=this.StrByteCountFun(this.mes[2].val);
                if(!(lengCode>=numCode[0]&&lengCode<=numCode[1])){
                    alert(this.language['K211_Limit']);
                    return false;
                };
                if(!this.reg.devCode.limit.test(this.mes[2].val)){
                    alert(this.language['K207_Type']);
                    return false;
                };
                var str=add.addDeviceSet({
                    sessionId:sessionId,
                    oem:oem,
                    id:this.addIDVal,
                    name:this.mes[1].val,
                    code:this.mes[2].val
                });
            };
            if (this.isPA) {
                var data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    cType: 'json',
                    xml:JSON.stringify(ConfirmData)
                });
                this.confirmResultJSON(data.data);
            } else {
                var data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    xml:str
                });
                this.confirmResult(data.data);
            }
        },
        confirmResultJSON:function(data){
            if(!data){
                this.$emit('msgHides',{hide:false,suc:false});
            }else{
                var result=(data.header || {}).result;
                var key = this.promptInfo(result);
                if(result===0){
                    this.$emit('msgHides',{hide:false,suc:true});
                    this.isHS=false;
                    this.isPA=false;
                    this.isSR=false;
                    this.init=true;
                    alert(this.language["K141_addSuccess"]);
                    this.$emit('refresh');
                }else if(result===100100001||result===''){
                    this.ajaxH.repeat=this.confirm;
                    this.$emit('refresh');
                }else{
                    this.$emit('msgHides',{hide:false,suc:false});
                    this.isHS=false;
                    this.isPA=false;
                    this.isSR=false;
                    this.init=true;
                    alert(this.language[key] == undefined ? key : this.language[key]);
                };
            };
        },
        confirmResult:function(data){
            if(!data){
                this.$emit('msgHides',{hide:false,suc:false});
            }else{
                var result=$(data).find('header').find('result').text();
                var key = this.promptInfo(result);
                if(result==='0'){
                    this.$emit('msgHides',{hide:false,suc:true});
                    this.isHS=false;
                    this.isPA=false;
                    this.isSR=false;
                    this.init=true;
                    alert(this.language["K141_addSuccess"]);
                    this.$emit('refresh');
                }else if(result==='100100001'||result===''){
                    this.ajaxH.repeat=this.confirm;
                    this.$emit('refresh');
                }else{
                    this.$emit('msgHides',{hide:false,suc:false});
                    this.isHS=false;
                    this.isPA=false;
                    this.isSR=false;
                    this.init=true;
                    alert(this.language[key] == undefined ? key : this.language[key]);
                };
            };
        },
        cancle:function(){
            this.$emit('msgHides',{hide:false,suc:false});
            this.isHS=false;
            this.isPA=false;
            this.isSR=false;
            this.init=true;
        },
        lang:function(){
            this.addIDVal='';
            this.mes[0].val='';
            this.mes[1].val='';
            this.mes[2].val='';
            this.mesr[0].val='';
            this.mesr[1].val='';
            this.mesr[2].val='';
            this.mesr[3].val='';
            if(!this.isLang){
                this.isLang=true;
            };
        },
        exist:function(d){
            this.list=d;
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:400px;
        height:280px;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-140px;
        margin-left:-200px;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:calc(100% - 24px);
        padding:20px;
        box-sizing: border-box;
    }
    .user-mes-in{
        width:100%;
        height:30px;
    }
    .user-mes-in+.user-mes-in{
        margin-top:10px;
    }
    .user-mes-name{
        width:120px;
        height:100%;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .user-mes-inp{
        width:calc(100% - 120px - 20px);
        height: 100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
        margin-top:30px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>





// WEBPACK FOOTER //
// src/components/AddDevice.vue